import { ERROR_ACTIONS } from '../constants/actions/error'

export const handleError = (error: Error) => {
  return {
    type: ERROR_ACTIONS.HANDLE_ERROR,
    error: error,
  }
}
